// Shared helpers for the ride app UI
export const STATE_LABELS = {
  REQUESTED: "Requested",
  BIDDING: "Finding drivers",
  DRIVER_SELECTED: "Driver selected",
  BID_ACCEPTED: "Bid accepted",
  DRIVER_EN_ROUTE: "Driver on the way",
  DRIVER_ARRIVED: "Driver arrived",
  GRACE_PERIOD: "Grace period",
  WAITING: "Waiting",
  TRIP_STARTED: "Trip started",
  TRIP_IN_PROGRESS: "On trip",
  TRIP_COMPLETED: "Completed",
  PASSENGER_CANCELLED: "Cancelled by passenger",
  DRIVER_CANCELLED: "Cancelled by driver",
  NO_SHOW: "No-show",
  SYSTEM_CANCELLED: "Cancelled",
};

export function naira(n) {
  return "\u20a6" + Number(n || 0).toLocaleString("en-NG");
}

export function StateBadge({ state }) {
  const active = !["TRIP_COMPLETED", "PASSENGER_CANCELLED", "DRIVER_CANCELLED", "NO_SHOW", "SYSTEM_CANCELLED"].includes(state);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${active ? "bg-[#2fd645]/15 text-[#2fd645]" : "bg-white/10 text-white/60"}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${active ? "bg-[#2fd645]" : "bg-white/40"}`} />
      {STATE_LABELS[state] || state}
    </span>
  );
}
